import CopyLink from '../src/CopyLink.tsx';
export default CopyLink;
